import { createBaseThemeOptions, palettes, createUnifiedTheme, defaultTypography } from '@backstage/theme';
import Tangram03 from '../assets/Tangram_03.svg';

export const puzzleTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#3B7BBE',
        light: '#4877AE', // 10% lighter main
        dark: '#1B5187', // 10% darker main
      },
      secondary: {
        main: '#61B44B',
        light: '#79C768', // 10% lighter main
        dark: '#4A913A', // 10% darker main
      },
      grey: {
        50: '#f7f8f9',
        100: '#F5F5F5',
        200: '#e9ecef',
        300: '#DBDBDB',
        400: '#ced4da',
        500: '#adb5bd',
        600: '#6c757d',
        700: '#495057',
        800: '#333333',
        900: '#212529',
      },
      navigation: {
        ...palettes.light.navigation,
        background: '#1E5A96',
        color: '#fff',
        indicator: '#fff',
        navItem: {
          hoverBackground: '#1B5187', // 10% darker main
        },
        submenu: {
          background: '#1B5187', // 10% darker main
        },
      },
      text: {
        primary: '#1E5A96',
      },
      background: {
        default: '#FFF',
      },
    },
  }),
  typography: {
    ...defaultTypography,
    fontFamily: 'Roboto, sans-serif',
  },
  components: {
    BackstageSidebarSubmenuItem: {
      styleOverrides: {
        selected: ({ theme }) => ({
          background: theme.palette.primary.light,
        }),
        item: ({ theme }) => ({
          color: theme.palette.grey[300],
        }),
        dropdownItem: ({ theme }) => ({
          '&:hover': {
            color: theme.palette.background,
          },
        }),
      },
    },
    BackstageHeader: {
      styleOverrides: {
        header: {
          backgroundImage: `url(${Tangram03})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right',
        },
        title: ({ theme }) => ({
          color: theme.palette.navigation.background,
        }),
        subtitle: ({ theme }) => ({
          color: theme.palette.navigation.background,
        }),
        rightItemsBox: ({ theme }) => ({
          color: theme.palette.navigation.background,
          gap: 44,
        }),
      },
    },
    BackstageHeaderLabel: {
      styleOverrides: {
        label: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
        value: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          background: 'linear-gradient(135deg,#46bcc0 22.79%,#61b44b 81.45%)',
          '&:hover': {
            background: 'linear-gradient(135deg,#3da8ac 22.79%,#4a913a 81.45%)',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
          },
          '&:active': {
            background: 'linear-gradient(135deg,#359197 22.79%,#3d7a2f 81.45%)',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        colorPrimary: ({ theme }) => theme.palette.primary.main,
      },
    },
  },
});
